// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 177 ? "home" : chunkId) + "." + {"177":"d8c44544","187":"97973c98","632":"97973c98","767":"c155fe25"}[chunkId] + ".css";
};